module.exports = __webpack_public_path__ + "img/cross_white.bb842326.svg";